import React, { useEffect } from "react";
import { BASE_URL } from '../constants';




const OccasionSection = ({ shopbytype = [] }) => {
  //const BASE_URL = BASE_URL; // 🔁 change if needed
  
  useEffect(() => {
    const sections = document.querySelectorAll(".portfolio-section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      {
        threshold: 0.6,
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="portfolio-wrapper py-5">
      <div className="discover-heading">
        <span>Shop by</span>
        <h2>TYPE</h2>
      </div>

      {/* 🔥 API DATA USE */}
      {shopbytype.map((item, index) => (
        <section className="portfolio-section" key={item.id}>
          <div
            className={`portfolio-card`}
            style={{
              backgroundImage: `url(${
                 BASE_URL +
                item.image?.replace(/\\/g, "/")
              })`,
            }}
          >
          </div>
        </section>
      ))}

      <style>{`
        .portfolio-wrapper {
          position: relative;
        }

        .portfolio-section {
          max-width: 1200px;
          margin: auto;
          padding: 20px 20px;
          position: sticky;
          top: 130px;
          height: 80vh;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.5s ease, opacity 0.5s ease;
        }

        .portfolio-card {
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          width: 100%;
          border-radius: 16px;
          display: flex;
          justify-content: space-between;
          overflow: hidden;
          min-height: 420px;
          transform: scale(0.95);
          opacity: 0.7;
          transition: all 0.6s ease;
        }

        .portfolio-card.yellow {
          background: linear-gradient(135deg, #fff, #f3ec12);
        }

        .portfolio-card.white {
          background: linear-gradient(135deg, #ffffff, #1527ff);
        }

        .portfolio-card.khayati {
          background: linear-gradient(135deg, #ffffff, #193050);
        }

        .portfolio-section.active .portfolio-card {
          transform: scale(1);
          opacity: 1;
        }

        .portfolio-content {
          padding: 40px;
          width: 55%;
          display: flex;
          flex-direction: column;
        }

        .portfolio-content h2 {
          font-size: 30px;
          margin: 20px 0;
        }

        .logo img {
          width: 120px;
        }

        .learn-btn {
          background: #000;
          color: #fff;
          padding: 10px 20px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          transition: 0.3s;
        }

        .learn-btn:hover {
          background: #c40000;
        }

        .portfolio-image {
          width: 45%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .portfolio-image img {
          max-height: 360px;
          width: auto;
        }

        @media (max-width: 900px) {
          .portfolio-card {
            flex-direction: column;
          }

          .portfolio-content,
          .portfolio-image {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default OccasionSection;
// // import React from "react";
// import React, { useEffect } from "react";

// const occasions = [
//   {
//     id: 1,
//     className: "yellow",
//     title: "Wedding Collection",
//     titleColor: "#a39707",
//     bgImage: "/assets/images/occassion-img/bracelets.jpg",
   
//   },
//   {
//     id: 2,
//     className: "white",
//     title: "Party Wear Jewellery",
//     titleColor: "#024CA1",
//     bgImage: "/assets/images/occassion-img/hoops-earring.jpg",
   
// },
// {
//     id: 3,
//     className: "khayati",
//     title: "Festive Special",
//     titleColor: "#042a62",
//     bgImage: "/assets/images/occassion-img/Statement-earring.jpg",
    
//   },
// {
//     id: 4,
//     className: "khayati",
//     title: "Festive Special",
//     titleColor: "#042a62",
//     bgImage: "/assets/images/occassion-img/Statement-Nacklace.jpg",
    
//   },
// {
//     id: 5,
//     className: "khayati",
//     title: "Festive Special",
//     titleColor: "#042a62",
//     bgImage: "/assets/images/occassion-img/Stud-earring.jpg",
    
//   },
// ];

// const OccasionSection = ({shopbytype=[]}) => {
//   useEffect(() => {
//     const sections = document.querySelectorAll(".portfolio-section");

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("active");
//           } else {
//             entry.target.classList.remove("active");
//           }
//         });
//       },
//       {
//         threshold: 0.6,
//       },
//     );

//     sections.forEach((section) => observer.observe(section));

//     return () => observer.disconnect();
//   }, []);
//   return (
//     <div className="portfolio-wrapper py-5">
//       <div className="discover-heading">
//         <span>Shop by</span>
//         <h2>TYPE</h2>
//       </div>
//       {occasions.map((item, index) => (
//         <section className="portfolio-section" key={item.id}>
//           <div
//             className={`portfolio-card ${item.className}`}
//             style={{ backgroundImage: `url(${item.bgImage})` }}
//           >
//             {/* <div className="portfolio-content"> */}
//               {/* <div className="logo">
//                 <img src={item.logo} alt="logo" />
//               </div>

//               <div className="category">
//                 <h2 style={{ color: item.titleColor }}>{item.title}</h2>
//               </div> */}

//               {/* <div>
//                 <button className="learn-btn">Shop Now</button>
//               </div> */}
//             {/* </div> */}

//             {/* <div className="portfolio-image">
//               <img src={item.image} alt="occasion" />
//             </div> */}
//           </div>
//         </section>
//       ))}

//       <style>{`
//         .portfolio-wrapper {
//           position: relative;
//         }

//         .portfolio-section {
//         max-width: 1200px;
//         margin: auto;
//         padding: 20px 20px;
//         position: sticky;
//         top: 130px;
//         height: 80vh;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         transition: transform 0.5s ease, opacity 0.5s ease;
//         }

//         .portfolio-card {
//         background-size: cover;
//         background-repeat: no-repeat;
//   background-position: center;
//         width: 100%;
//         border-radius: 16px;
//         display: flex;
//         justify-content: space-between;
//         overflow: hidden;
//         min-height: 420px;
//         transform: scale(0.95);
//         opacity: 0.7;
//         transition: all 0.6s ease;
//         }

//         .portfolio-card.yellow {
//           background: linear-gradient(135deg, #fff, #f3ec12);
//         }

//         .portfolio-card.white {
//           background: linear-gradient(135deg, #ffffff, #1527ff);
//         }

//         .portfolio-card.khayati {
//           background: linear-gradient(135deg, #ffffff, #193050);
//         }
//           .portfolio-section.active .portfolio-card {
//   transform: scale(1);
//   opacity: 1;
// }

//         .portfolio-content {
//           padding: 40px;
//           width: 55%;
//           display: flex;
//           flex-direction: column;
//         }

//         .portfolio-content h2 {
//           font-size: 30px;
//           margin: 20px 0;
//         }

//         .logo img {
//           width: 120px;
//         }

//         .learn-btn {
//           background: #000;
//           color: #fff;
//           padding: 10px 20px;
//           border: none;
//           border-radius: 5px;
//           cursor: pointer;
//           transition: 0.3s;
//         }

//         .learn-btn:hover {
//           background: #c40000;
//         }

//         .portfolio-image {
//           width: 45%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .portfolio-image img {
//           max-height: 360px;
//           width: auto;
//         }

//         @media (max-width: 900px) {
//           .portfolio-card {
//             flex-direction: column;
//           }

//           .portfolio-content,
//           .portfolio-image {
//             width: 100%;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default OccasionSection;
